import { IconUserPlus, IconDownload } from "@tabler/icons-react";

import { useCommunity } from "@contexts/CommunityContext";

import { Button, Text } from "@fragments";

import "./styles.scss";

export default function TableToolbar({ records, loading, communityId, onExport }) {
  const { community } = useCommunity();

  function handleInvite() {
    if (!communityId) return;
    community.triggerShareModal(communityId);
  }

  const label = loading
    ? "Carregando membros..."
    : `${records} ${records === 1 ? "membro encontrado" : "membros encontrados"}`;

  return (
    <div className="members-list-toolbar">
      <Text.span contrast={5}>{label}</Text.span>

      <div className="members-list-toolbar__actions">
        <Button
          color="inverse"
          size="small"
          startIcon={<IconUserPlus size={16} stroke={2} />}
          onClick={handleInvite}
          preventLoading
          text="Convidar membro"
        />
        <Button
          color="inverse"
          size="small"
          startIcon={<IconDownload size={16} stroke={2} />}
          onClick={onExport}
          disabled={!onExport}
          preventLoading
          text="Exportar"
        />
      </div>
    </div>
  );
}
